import React from 'react';
import { useTranslation } from 'react-i18next';
import { ISchoolStudents, ITrainerOption, CourseUI, ICourseLessonUI } from '../../../../shared/interfaces/ridingCourse/IRidingCourse';
import { IEqUiSelectModel } from '../../../../shared/interfaces/ILocationDto';
import SchoolCourseLessonList from '../CourseLessonList/SchoolCourseLessonLisr';
import { IGetSchoolTrainingInfoDto } from '../../../../shared/interfaces/GetSchoolTrainingInfoDto';
import { ITraining } from '../../trainingCourseCreate/TrainingCourseCreate';
import { IGetTrainingDto } from '../../../../shared/interfaces/trainingDto/IGetTrainingDto';
import { IGetSchoolTrainingDto } from '../../../../shared/interfaces/schoolTraining/IGetSchoolTrainingDto';
import { GetSchoolStudentsDto } from '../../../../shared/interfaces/schoolTraining/school';
import { IStudentHorseList } from '../../../../shared/interfaces/horse/IHorses';

export interface ILessonRidingCourse {
    onEditLesson?: (data: ICourseLessonUI) => void;
    onRemoveLessonOrder?: (lessonId:string,order: any, refund: boolean, refundAmount?: number) => void;

    trainings: Array<Object>
    weekDays: IEqUiSelectModel[];
    schoolStudentsData?: ISchoolStudents[];
    studentHorsesList?: IStudentHorseList[];
    trainersOptions: ITrainerOption[];
    editCourse: any;
    isStudent?: boolean;
    onCourseLessonJoinRequest?: (lessonId:string) => void;
    onPayNowLessonOrder?: (orderId:string) => void;

}


const LessonRidingCourse: React.FC<ILessonRidingCourse> = ({
    onEditLesson,
    trainings,
    weekDays,
    schoolStudentsData,
    studentHorsesList,
    trainersOptions, 
    editCourse,
    onRemoveLessonOrder, 
    isStudent,
    onCourseLessonJoinRequest,
    onPayNowLessonOrder
}) => {


    const { t } = useTranslation();

    return (
        <div>
            <h2>{t("listOfLessons")}</h2>
            <SchoolCourseLessonList
            isStudent={isStudent}
                trainings={trainings}
                editCourse={editCourse}
                schoolStudentsData={schoolStudentsData}
                studentHorsesList={studentHorsesList}
                trainersOptions={trainersOptions}
                weekdays={weekDays}
                onEditLesson={onEditLesson}
                onRemoveLessonOrder={onRemoveLessonOrder}
                onCourseLessonJoinRequest={onCourseLessonJoinRequest}
                onPayNowLessonOrder={onPayNowLessonOrder}
            />
        </div>
    );
};

export default LessonRidingCourse;

